import { formatCampaignInfoDate } from './campaignInfoAdapter'

export const FINAL_RESULTS_TARGET_PCT = 95

export const EMPTY_FINAL_RESULTS = {
  available: false,
  onTime: 0,
  late: 0,
  overdue: 0,
  assigned: null,
  onTimePct: 0,
  inclLatePct: 0,
  targetPct: FINAL_RESULTS_TARGET_PCT,
  targetMet: false,
  closedOn: null,
  deadlineWas: null,
  extendedCount: 0,
  frozen: true,
}

export const adaptCampaignFinalResults = (payload) => {
  if (!payload?.available) {
    return EMPTY_FINAL_RESULTS
  }

  const assigned = payload.assigned ?? 0
  const onTime = payload.onTime || 0
  const late = payload.late || 0
  const overdue = payload.overdue || 0
  const targetPct = payload.targetPct ?? FINAL_RESULTS_TARGET_PCT
  const onTimePct = payload.onTimePct ?? 0
  const inclLatePct = payload.inclLatePct ?? 0

  return {
    available: true,
    onTime,
    late,
    overdue,
    assigned,
    onTimePct,
    inclLatePct,
    targetPct,
    targetMet: Boolean(payload.targetMet),
    closedOn: formatCampaignInfoDate(payload.closedOn),
    deadlineWas: formatCampaignInfoDate(payload.deadlineWas),
    extendedCount: payload.extendedCount || 0,
    frozen: true,
  }
}
